// extracted by mini-css-extract-plugin
export default {"container":"Exhibitions_container__2Gvuh","inner":"Exhibitions_inner__U5O7b"};